export default "__VITE_ASSET__DLnf07Fp__"